import { ReactElement, useEffect } from "react";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { ElementProps } from "../../functionalComponents/RenderPage";
import { createLocation, PageElementsFamily } from "../../state/page";
import { AutoPlayAtom } from "../../state/ui";

const AutoPlay = function({ atomId, pageIndex }: ElementProps): ReactElement<ElementProps> {
  const key = createLocation(pageIndex, atomId);
  const elementData = useRecoilValue(PageElementsFamily(key)).data;
  const setAutoPlayAtom = useSetRecoilState(AutoPlayAtom);

  useEffect(() => {
    if (elementData.type !== "autoplay:") return;
    const autoPlay = elementData.content && typeof elementData.content === "string"
      ? parseFloat(elementData.content)
      : false;

    const loop = elementData?.modifier && elementData.modifier["loop:"] === "forever"
      ? elementData.modifier["loop:"]
      : "once" as "once" | "forever";
    setAutoPlayAtom({ autoPlay, loop });
  });
  return <></>;
};

export default AutoPlay;
